<div class="container-fluid mt-4">
  <!-- Loading State -->
  <div *ngIf="loading" class="alert alert-info text-center">
    <span class="spinner-border spinner-border-sm me-2"></span>
    Loading batch details...
  </div>

  <!-- Batch Detail -->
  <div *ngIf="!loading && batch" class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h3 class="mb-0">Batch Detail - {{ batch.merchantName }}</h3>
      <div>
        <button class="btn btn-sm btn-secondary me-2" (click)="refreshDetail()">
          <i class="fas fa-sync"></i> Refresh
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="goBack()">
          <i class="fas fa-arrow-left"></i> Back
        </button>
      </div>
    </div>

    <div class="card-body">
      <!-- Batch Summary -->
      <div class="row mb-4">
        <div class="col-md-3">
          <strong>Status:</strong><br>
          <span class="badge" [ngClass]="'bg-' + getStatusBadgeClass(batch.displayStatus)">
            {{ batch.displayStatus }}
          </span>
        </div>
        <div class="col-md-3">
          <strong>Products:</strong><br>
          {{ batch.totalProducts }} products, {{ batch.totalSkus }} SKUs
        </div>
        <div class="col-md-3">
          <strong>Created:</strong><br>
          {{ batch.createdTime | date:'short' }}
        </div>
        <div class="col-md-3">
          <strong>Retry Count:</strong><br>
          {{ batch.retryCount }} / {{ batch.maxRetries }}
        </div>
      </div>

      <!-- Error Message (if any) -->
      <div class="alert alert-danger" *ngIf="batch.tikTokResponseMessage">
        <strong>TikTok Error (Code {{ batch.tikTokResponseCode }}):</strong><br>
        {{ batch.tikTokResponseMessage }}
      </div>

      <!-- Next Retry Time (if Failed) -->
      <div class="alert alert-warning" *ngIf="batch.status === 'Failed' && batch.nextRetryTime">
        <strong>Next Retry Scheduled:</strong> {{ batch.nextRetryTime | date:'short' }}
      </div>

      <!-- Additional Info -->
      <div class="row mb-4 border-top pt-3">
        <div class="col-md-4">
          <strong>Batch ID:</strong><br>
          <code>{{ batch.id }}</code>
        </div>
        <div class="col-md-4" *ngIf="batch.createdActivityId">
          <strong>Activity ID:</strong><br>
          <code>{{ batch.createdActivityId }}</code>
        </div>
        <div class="col-md-4" *ngIf="batch.lastUsedProxy">
          <strong>Last Used Proxy:</strong><br>
          <code>{{ batch.lastUsedProxy }}</code>
        </div>
      </div>

      <!-- Products in Batch -->
      <h5 class="mt-4 mb-3">Products in Batch</h5>
      <div class="table-responsive">
        <table class="table table-sm table-striped">
          <thead class="table-light">
            <tr>
              <th style="width: 40%;">Product</th>
              <th>Product ID</th>
              <th>SKU Count</th>
              <th>Discounted Price</th>
              <th style="width: 10%;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of batch.items">
              <td>{{ item.productTitle }}</td>
              <td><code>{{ item.productId }}</code></td>
              <td>{{ item.variationCount }}</td>
              <td>{{ item.discountedPrice | currency }}</td>
              <td>
                <button class="btn btn-xs btn-link"
                        (click)="toggleItemExpansion(item.productId)"
                        *ngIf="item.variations && item.variations.length > 0">
                  <i class="fas" [ngClass]="isItemExpanded(item.productId) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </td>
            </tr>
            <!-- SKU Details (expandable) -->
            <ng-container *ngFor="let item of batch.items">
              <tr class="table-secondary"
                  *ngIf="isItemExpanded(item.productId) && item.variations">
                <td colspan="5">
                <strong>SKU Details for {{ item.productTitle }}</strong>
                <div class="table-responsive mt-2">
                  <table class="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Variation ID</th>
                        <th>Seller SKU</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Tax Excl. Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let variation of item.variations">
                        <td><code>{{ variation.variationId }}</code></td>
                        <td>{{ variation.sellerSku }}</td>
                        <td class="text-center">{{ variation.quantity }}</td>
                        <td>{{ variation.price | currency }}</td>
                        <td>{{ variation.taxExclusivePrice | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- No items message -->
      <div *ngIf="!batch.items || batch.items.length === 0" class="alert alert-info mt-3">
        No products in this batch.
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="!loading && !batch" class="alert alert-danger">
    Failed to load batch details. Please try again.
  </div>
</div>
